import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages } from "@fortawesome/free-solid-svg-icons";
import PhotoGalleryModal from "@/modules/booking/components/PhotoGalleryModal";
import { DEFAULT_ROOM_IMAGE } from "@/constants/AppConfig";

interface RoomPhotoGridProps {
  images?: string[];
  thumbnail?: string;
  name?: string;
  variant?: "mobile" | "desktop";
}

const RoomPhotoGrid: React.FC<RoomPhotoGridProps> = ({
  images,
  thumbnail,
  name,
  variant = "mobile",
}) => {
  const isDesktop = variant === "desktop";
  const [galleryOpen, setGalleryOpen] = useState(false);

  // รวม thumbnail + images เป็น list เดียว (thumbnail ขึ้นก่อน) — เฉพาะรูปจริงเท่านั้น
  // ห้ามปน DEFAULT_ROOM_IMAGE เข้ามา ไม่งั้น gallery จะมี placeholder โผล่เป็นสไลด์แรกทับรูปจริง
  const allImages = thumbnail
    ? [thumbnail, ...(images ?? []).filter((src) => src !== thumbnail)]
    : images ?? [];
  const hasRealImage = allImages.length > 0;
  const displaySrc = hasRealImage ? allImages[0] : DEFAULT_ROOM_IMAGE;
  const isClickable = hasRealImage;
  const showGalleryIcon = allImages.length > 1;

  const imgWidth = isDesktop ? "100%" : "100%";
  const imgHeight = isDesktop ? "100%" : 160;
  const imgBorderRadius = isDesktop ? 12 : 0;

  return (
    <>
      <div style={{ width: imgWidth, position: "relative" }}>
        <img
          src={displaySrc}
          alt={name}
          onClick={isClickable ? () => setGalleryOpen(true) : undefined}
          style={{
            width: "100%",
            height: imgHeight,
            objectFit: "cover",
            borderRadius: imgBorderRadius,
            cursor: isClickable ? "pointer" : "default",
            display: "block",
          }}
        />
        {showGalleryIcon && (
          <FontAwesomeIcon
            icon={faImages}
            aria-hidden="true"
            style={{
              position: "absolute",
              bottom: 8,
              right: 8,
              color: "#fff",
              fontSize: 16,
              filter: "drop-shadow(0 1px 3px rgba(0,0,0,0.6))",
              pointerEvents: "none",
            }}
          />
        )}
      </div>
      {isClickable && (
        <PhotoGalleryModal
          images={allImages}
          open={galleryOpen}
          initialIndex={0}
          onClose={() => setGalleryOpen(false)}
        />
      )}
    </>
  );
};

export default RoomPhotoGrid;
